import React from 'react';
import {connect} from 'react-redux';

import {
    Alert,
    Card, CardBody, CardTitle,
    FormGroup
} from 'reactstrap';
import {Link} from 'react-router';
import {Field, reduxForm} from 'redux-form';

import {loginUser} from './actions/authentication';

import AuthContainer from './AuthContainer';
import {InputField} from '../../validation/ReduxFormInput';
import {FormAsyncButton} from "../../components/controls/buttons/AsyncButton";

class LoginForm extends React.Component {

    componentDidMount() {
        document.body.classList.toggle('dark-background', true);
    }

    render() {
        // handleSubmit, pristine, reset, and submitting are provided by redux-form
        const {error, handleSubmit, pristine, submitting, handleLogin} = this.props;
        return (
            <AuthContainer>
                <Card style={{margin: 'auto'}}>
                    <CardBody>
                        <CardTitle className="center">Sign in to your account</CardTitle>
                        <hr/>
                        <form onSubmit={handleSubmit(handleLogin)}>
                            <FormGroup>
                                <Field name="username" label="Email" component={InputField} type="email"/>
                            </FormGroup>
                            <FormGroup>
                                <Field name="password" label="Password" component={InputField} type="password"/>
                            </FormGroup>
                            <FormAsyncButton
                                type="submit"
                                color="primary"
                                acting={submitting}
                                disabled={pristine}
                                block
                            >
                                Sign In
                            </FormAsyncButton>
                            {
                                error &&
                                <div className="center" style={{marginTop: '5px'}}>
                                    <Alert color="danger">
                                        {error}
                                    </Alert>
                                </div>
                            }
                        </form>
                        <hr/>
                        <p className="center">
                            New to PolyRents? <Link to="/register">Sign Up</Link>
                        </p>
                    </CardBody>
                </Card>
            </AuthContainer>
        );
    }
}

// validation function given to redux-form
const validate = values => {
    const errors = {};

    !values.username && (errors.username = 'Required');
    !values.password && (errors.password = 'Required');

    return errors;
};

LoginForm = reduxForm({
    form: 'login', // unique name for form
    validate
})(LoginForm);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin(user) {
            return dispatch(
                loginUser(user)
            );
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);


// WEBPACK FOOTER //
// ./src/containers/authentication/LoginForm.js